import React from 'react';
import { Container } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface PageContainerProps {
  children: React.ReactNode;
  /** Max content width in px. Matches the dashboard mockup (1240) by default. */
  maxWidth?: number;
  sx?: SxProps<Theme>;
}

/**
 * Centered, width-constrained page shell used across the primary tabs so the
 * whole app shares the dashboard mockup's layout rhythm.
 */
const PageContainer: React.FC<PageContainerProps> = ({ children, maxWidth = 1240, sx }) => (
  <Container maxWidth={false} sx={{ maxWidth, mt: 3, ...sx }}>
    {children}
  </Container>
);

export default PageContainer;
